import { Grid, makeStyles } from '@material-ui/core';
import { Body1Text, Body2Text, Modal } from 'design-system';

const useStyles = makeStyles(() => ({
  mainText: {
    marginTop: 15,
    marginBottom: 10,
  },
}));

type Props = {
  onClose: () => void;
  open: boolean;
};

const PurchaseInvoiceModal = ({ open, onClose }: Props): JSX.Element => {
  const classes = useStyles();
  return (
    <Modal
      data-testid="sales-web-invoice-modal"
      title="Factura de compra"
      open={open}
      maxWidth="sm"
      onCloseRequested={onClose}
    >
      <Grid container>
        <Grid
          item
          container
          xs={12}
          justifyContent="center"
          alignItems="center"
        >
          <img
            data-testid="sales-web-invoice-image"
            src="/svg/img_invoice_help.svg"
            alt="invoice"
          />
        </Grid>

        <Grid
          data-testid="sales-web-invoice-primary-text"
          item
          xs={12}
          className={classes.mainText}
        >
          <Body1Text align="center">
            <strong>
              La factura de compra deberá ser emitida <br />
              por alguna agencia distribuidora
              <br />
              reconocida a nivel país.
            </strong>
          </Body1Text>
        </Grid>

        <Grid item xs={12} data-testid="sales-web-invoice-secondary-text">
          <Body2Text color="textSecondary" align="center">
            Copia de la factura de compra (máximo 5 días <br />
            hábiles desde la fecha emitida) O en su defecto <br />
            carta de la Agencia Distribuidora, haciendo constar <br />
            la fecha de entrega del vehículo.
          </Body2Text>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default PurchaseInvoiceModal;
